import {mergeBufferGeometries} from "three/examples/jsm/utils/BufferGeometryUtils";
import {Mesh} from "three";

export default class MeshUtils {
    static mergeMeshes(meshes){
        //TODO: Implement

        const geometries = [];
        meshes.forEach(mesh => {
            const geometry = mesh.geometry.clone();
            mesh.updateMatrixWorld(true);
            mesh.updateMatrix();
            geometry.applyMatrix4(mesh.matrixWorld);
            mesh.updateMatrix();
            geometries.push(geometry);
            mesh.geometry.dispose();
        });

        const merged = mergeBufferGeometries(geometries);
        const mesh = new Mesh(merged, meshes[0].material);
        mesh.frustumCulled = true;

        meshes.forEach(m => {
            if(m.parent) m.parent.remove(m);
        })

        return mesh;
    }
}